"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MetaStats: function() {
        return _metaStats.default;
    },
    default: function() {
        return _default;
    }
});
const _metaStats = /*#__PURE__*/ _interop_require_default(require("./metaStats"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const _default = _metaStats.default;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIjxhbm9uPiJdLCJzb3VyY2VzQ29udGVudCI6WyIndXNlIHN0cmljdCc7XG5cbmltcG9ydCBNZXRhU3RhdHMgZnJvbSAnLi9tZXRhU3RhdHMnO1xuXG5leHBvcnQgZGVmYXVsdCBNZXRhU3RhdHM7XG5leHBvcnQgeyBNZXRhU3RhdHMgfTtcbiJdLCJuYW1lcyI6WyJNZXRhU3RhdHMiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7OztJQUtTQSxTQUFTO2VBQVRBLGtCQUFTOztJQURsQixPQUF5QjtlQUF6Qjs7O2tFQUZzQjs7Ozs7O01BRXRCLFdBQWVBLGtCQUFTIn0=